import { Link } from "react-router-dom";
import { useSiteConfig, useUiLabels } from "../context/LocaleContext";

const footerEase = "transition-[opacity,transform,color] duration-700 ease-fluid";

export default function SiteFooter() {
  const config = useSiteConfig();
  const ui = useUiLabels();
  const links = ui.nav;

  return (
    <footer className="relative z-10 shrink-0 border-t border-white/[0.06] bg-[#050505]/80 px-4 pb-8 pt-6 md:px-8">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 md:flex-row md:items-center md:justify-between">
        <p className="text-center text-[13px] text-zinc-500 md:text-left">
          © {new Date().getFullYear()} {config.name} {config.surname}. {ui.footer.tagline}
        </p>
        <nav aria-label={ui.footer.navAria} className="flex flex-wrap justify-center gap-x-5 gap-y-2 md:justify-end">
          {links.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              className={`text-[13px] text-zinc-400 hover:text-emerald-200/90 ${footerEase} active:scale-[0.98]`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
